import React, { Component } from 'react';
import '../styles/About.css';
import aboutImg from '../medias/about.jpg'

class About extends Component {
    render() {
        return (
            <div className="page-about">
                <img src={aboutImg} alt="about"/>
            </div>
        )
    }
}

export default About;


// WEBPACK FOOTER //
// ./src/modules/About.js